import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceCard from '../../components/common/ServiceCard';
import SEO from '../../components/common/SEO';
import { 
  FaLanguage, 
  FaHome, 
  FaUniversity, 
  FaBriefcase, 
  FaGlobe, 
  FaBalanceScale 
} from 'react-icons/fa';

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      title: 'language_integration',
      description: 'language_integration_description',
      icon: FaLanguage
    },
    {
      title: 'apartment_search',
      description: 'apartment_search_description',
      icon: FaHome
    },
    {
      title: 'academic_refugee_support',
      description: 'academic_refugee_support_description',
      icon: FaUniversity
    },
    {
      title: 'career_guidance',
      description: 'career_guidance_description',
      icon: FaBriefcase
    },
    {
      title: 'cultural_orientation',
      description: 'cultural_orientation_description',
      icon: FaGlobe
    },
    {
      title: 'legal_assistance',
      description: 'legal_assistance_description',
      icon: FaBalanceScale
    }
  ];

  return (
    <div className="py-12 bg-gray-50">
      <SEO 
        title={t('seo.servicesTitle')} 
        description={t('seo.servicesDescription')}
      />
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              title={t(`services.${service.title}`)}
              description={t(`services.${service.description}`)}
              icon={service.icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;